import { useNavigate, useSearchParams } from 'react-router';
import { Location } from '@/utils/windowsUtils';

const APP_URL_PARAM = 'appUrl';

const useBackToLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appUrl = searchParams.get(APP_URL_PARAM);

  return () => {
    if (appUrl) {
      Location.change(appUrl);
      return;
    }
    navigate('/login');
  };
};

export default useBackToLogin;
